import { css } from 'lit-element';
const style = css`
fc-button-group {
  white-space: nowrap;
}`;
export default style;
